export const BIRTHDAY_FORMAT = {
  'YYYY/MM/DD': 'YYYY/MM/DD',
  'YYYY/MM': 'YYYY/MM',
  'MM/DD': 'MM/DD',
};
